import { useMutation } from '@tanstack/react-query';

import { removeEstimateUser } from '@widgets/EstimateInformation/api/removeEstimateUser';

export const useRemoveEstimateUserQuery = () =>
    useMutation({
        mutationKey: ['removeEstimateUser'],
        mutationFn: removeEstimateUser,
    });
